import React, { useEffect } from 'react';
import logo from '../../assets/images/drive-day-logo.png';
import { Link } from 'react-router-dom';
import StickyMenu from '../../lib/StickyMenu';
import Navigation from '../Navigation';

function HeaderAbout({ action }) {
    useEffect(() => {
        StickyMenu();
    });
    return (
        <>
            <header className="dd-header-area dd-sticky dd-red">
                <div className="container">
                    <div className="header-nav-box">
                        <div className="row align-items-center">
                            <div className="col-lg-2 col-md-4 col-sm-5 col-6 order-1 order-sm-1">
                                <div className="dd-logo-box">
                                    <a href="/">
                                        <img src={logo} alt="Drive.Day" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-1 col-sm-1 order-3 order-sm-2">
                                <div className="dd-header-main-menu">
                                    <Navigation />
                                </div>
                            </div>
                            <div className="col-lg-4  col-md-7 col-sm-6 col-6 order-2 order-sm-3">
                                <div className="dd-btn-box text-right">
                                    <Link className="main-btn" to="/login">
                                        Login
                                    </Link>
                                    <div
                                        onClick={(e) => action(e)}
                                        className="toggle-btn ml-30 canvas_open d-lg-none d-block"
                                    >
                                        <i className="fa-jelly-fill fa-regular fa-bars"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default HeaderAbout;
